import React, { useState } from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  addMonths,
  subMonths,
  eachDayOfInterval,
  getDay,
  isSameMonth
} from "date-fns";

import {ReactComponent as LeftIcon} from "../../../icons/extra_icons/left.svg"


import classnames from "classnames"
import Styles from "./MainCalendar.module.scss"; // Import the SCSS file for styling

const Calendar = () => {

  const currentDate = (new Date()).getDate()

  const [currentMonth, setCurrentMonth] = useState(new Date());

  const prevMonth = () => {
    setCurrentMonth(subMonths(currentMonth, 1));
  };

  const nextMonth = () => {
    setCurrentMonth(addMonths(currentMonth, 1));
  };

  const firstDayOfMonth = startOfMonth(currentMonth);
  const lastDayOfMonth = endOfMonth(currentMonth);

  const daysInMonth = eachDayOfInterval({
    start: firstDayOfMonth,
    end: lastDayOfMonth
  });

  // An array to represent the order of days in the week (starting from Sunday)
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Find the index of the first day of the month (0 for Sunday, 1 for Monday, etc.)
  const firstDayIndex = getDay(firstDayOfMonth);

  // Find the index of the last day of the month (0 for Sunday, 1 for Monday, etc.)
  const lastDayIndex = getDay(lastDayOfMonth);

  // Create an array of placeholders for days before the first day of the month
  const leadingDays = new Array(firstDayIndex).fill(null);

  // Create an array of placeholders for days after the last day of the month
  const trailingDays = new Array(6 - lastDayIndex).fill(null);

  return (
    <div className={Styles.container}>
      <div className={Styles.top_bar}>
        <div className={Styles.date}>{format(currentMonth, "MMMM yyyy")}</div>
        <div className={Styles.buttons}>
          <button onClick={prevMonth}><LeftIcon/></button>
          <button onClick={nextMonth} style={{transform:"scaleX(-1)"}}><LeftIcon/></button>
        </div>
      </div>
      <div className={Styles.calendar}>
        <div className={Styles.weekdays}>
          {weekdays.map((day) => (
            <div key={day}>{day}</div>
          ))}
        </div>
        <div className={Styles.days}>
          {leadingDays.map((_, index) => (
            <div key={`leading-${index}`} className={classnames(Styles.day, Styles.empty)}></div>
          ))}
          {daysInMonth.map((date: any) => (
            <div
              key={date.getTime()}
              className={classnames(Styles.day, isSameMonth(date, currentMonth) ? "" : "empty", String(currentDate)===format(date, "d") &&Styles.active_day)}
            >
              {format(date, "d")}
            </div>
          ))}
          {trailingDays.map((_, index) => (
            <div key={`trailing-${index}`} className={classnames(Styles.day, Styles.empty)}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Calendar;
